/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Vehicle Battery Icon component.
 */
const SystemVehicleBatteryIcon = ({
  size = IconSize.medium,
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.5 8.25H4.95C4.70147 8.25 4.5 8.45147 4.5 8.7V16.8C4.5 17.0485 4.70147 17.25 4.95 17.25H19.05C19.2985 17.25 19.5 17.0485 19.5 16.8V8.7C19.5 8.45147 19.2985 8.25 19.05 8.25H16.5M7.5 8.25V6.75H9V8.25M7.5 8.25H9M16.5 8.25V6.75H15V8.25M16.5 8.25H15M9 8.25H15' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14 13H16H18' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M6 13H8M8 13H10M8 13V11M8 13V15' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(SystemVehicleBatteryIcon);
